<script setup lang="ts">
const { initSmarticoError, isReadyGamefication } =
  storeToRefs(useSmarticoInit());

const { gamificationActiveAndShow } = storeToRefs(useSmarticoConfigs());

const loadComponent = computed(() => {
  return (
    gamificationActiveAndShow.value &&
    !initSmarticoError.value &&
    isReadyGamefication.value
  );
});
</script>

<template>
  <div :class="$style.centerPage">
    <SmarticoAlertsAndLoader v-if="!loadComponent" />
    <SmarticoBadges v-else />
  </div>
</template>

<style module lang="postcss">
.centerPage {
  @apply w-full min-h-[600px] flex items-center justify-center relative;
}
</style>
